module.exports = __webpack_public_path__ + "img/9.ec0055fb.jpg";